<div id="tc-container" class="content-container">
    <app-terms-and-condition-content></app-terms-and-condition-content>
</div>
